// @flow

import React from 'react';
import { shape, string, number } from 'prop-types';

const ImageSlot = ({ image }: { image: any }) => {
  const imageScale = image && image.scales ? image.scales.preview : '';

  if (!imageScale) {
    return '';
  }
  return (
    <figure>
      <img
        src={imageScale.download}
        width={imageScale.width}
        height={imageScale.height}
        className="item-image"
      />
    </figure>
  );
};

ImageSlot.propTypes = {
  image: shape({
    scales: shape({
      thumb: shape({
        width: number.isRequired,
        height: number.isRequired,
        download: string.isRequired,
      }),
    }),
  }),
};

export default ImageSlot;
